export default __webpack_public_path__ + "static/media/pexels-vojtech-okenka-392018.510bda2f.jpg";